import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { GoogleLogin } from '@react-oauth/google';


import NavBar from '../layout/NavBar';
import { sendGoogleLogin } from '../../services/api/login';
import { setUserInfo, setAuthToken, setLabPartnerInfo } from '../../actions';
import config from '../../config';
const OuterComponent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
  align-self: stretch;
  height: 100%;
`;

const GoogleLoginButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 10px 24px 10px 12px;
  border: none;
  border-radius: 999px;
  background: #1a73e8;
  color: #ffffff;
  cursor: pointer;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px rgba(60, 64, 67, 0.15);
  transition: background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: #1669c1;
    box-shadow: 0 1px 3px rgba(60, 64, 67, 0.3), 0 4px 8px rgba(60, 64, 67, 0.15);
  }

  &:active {
    background: #1257a5;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.25);
  }
`;

const GoogleIconBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: #ffffff;
  border-radius: 50%;
`;

const GoogleGIcon = () => (
  <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
    <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" />
    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
  </svg>
);

class Login extends Component {

  history = this.props.history;

  // componentDidMount() {
  //   if (this.props.user && this.props.user.token) {
  //     this.props.history.push('/revamp-offline-consults');
  //   }
  // }

  googleLogin = (credentialResponse) => {
    const dispatch = this.props.dispatch;
    return sendGoogleLogin(credentialResponse.credential)
      .then(response => {
        if (response && response.body.message === 'success') {
          dispatch(setUserInfo(response.body.result));
          dispatch(setAuthToken(response.headers.authorization));
          if (response.body.partnerInfo) {
            dispatch(setLabPartnerInfo(response.body.partnerInfo));
          }
          // return response.operatorDetails;
          return response;
        }
        throw new Error('Logged message not correct');
      })
      .then(resp => {
        const home = resp.body.result.home;
        switch (home) {
          case 'offline': {
            this.props.history.push('/revamp-offline-consults');
            break;
          }
          case 'payment': {
            this.props.history.push('/payment-requests');
            break;
          }
          case 'support': {
            this.props.history.push('/customer-support');
            break;
          }
          case 'labs-dashboard': {
            this.props.history.push('/labs-orders');
            break;
          }
          case 'reimbursement': {
            this.props.history.push('/reimburse-claims');
            break;
          }
          default:
            break;
        }
      })
      .catch(err => {
        toast.error('Incorrect username or password provided.');
      });
  };

  handleProxyLogin = () => {
    const returnTo = encodeURIComponent(`${window.location.origin}/auth/return`);
    const env = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV;
    const proxyBaseUrl = 'https://api.getvisitapp.com/v3'
    window.location.href = `${proxyBaseUrl}/new-auth/on-demand/login?returnTo=${returnTo}`;
  };

  onError = (err) => {
    console.error('Login failed', err);
  };
  render() {
    return (
      <OuterComponent>
        <NavBar />
        <div style={{padding:'18rem', marginTop: '7rem', display: 'flex', justifyContent: 'space-around'}}>
          {config.useTestAuthProxy ? (
            <GoogleLoginButton onClick={this.handleProxyLogin} type="button">
              <GoogleIconBadge>
                <GoogleGIcon />
              </GoogleIconBadge>
              Sign in with Google
            </GoogleLoginButton>
          ) : (
            <GoogleLogin
              clientId={config.googleAuthConfig.clientId}
              onSuccess={this.googleLogin}
              onError={this.onError}
              scope={config.googleAuthConfig.scopes}
              prompt="consent"
              layout="horizontal"
              theme="filled_blue"
              shape="pill"
            />
          )}
        </div>
      </OuterComponent>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(Login);
